import script from "./LegalSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalSection.vue?vue&type=script&setup=true&lang=js"

import "./LegalSection.vue?vue&type=style&index=0&id=4562c94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4562c94e"]])

export default __exports__